import { useMediaQuery } from "react-responsive";

const useIsTiny = () => useMediaQuery({ query: "(max-width: 450px)" });
const useIsMobileLandscape = () => useMediaQuery({ query: "(max-width: 767px)" });
const useIsMobile = () => useMediaQuery({ query: "(max-width: 768px)" });
const useIsTablet = () => useMediaQuery({ query: "(max-width: 992px)" });
const useIsSmaller1024 = () => useMediaQuery({ query: "(max-width: 1024px)" });
const useIsDesktop = () => useMediaQuery({ query: "(max-width: 1200px)" });
const useIsSmaller1400 = () => useMediaQuery({ query: "(max-width: 1400px)" });

const useIsLargeScreen = () => useMediaQuery({ query: "(min-width: 992px)" });
const useIsHuge = () => useMediaQuery({ query: "(min-width: 1401px)" });
const useIsBigScreen = () => useMediaQuery({ query: "(min-width: 1539px)" });

export {
    useIsTiny,
    useIsMobile,
    useIsTablet,
    useIsSmaller1024,
    useIsLargeScreen,
    useIsSmaller1400,
    useIsDesktop,
    useIsHuge,
    useIsBigScreen,
    useIsMobileLandscape
}